import React, {useState} from "react"
import {Button, FormLabel, Modal} from "react-bootstrap"
import {delPerformance, postPerformance, putPerformance} from "../../lib/api";
import {EditableText} from "../Shared/EditableWidgets";

function PerformanceEdit(props: {
  performance: any,
  loadData: any,
  show: boolean;
  onHide: () => void;
}) {
  const {performance, loadData, show, onHide} = props;
  const [error, setError] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('Add Performance');

  function showModal() {
    setTitle(performance.id ? 'Edit Performance' : 'Add Performance');
    setName(performance.name);
    setUrl(performance.url);
    setError(null);
  }

  function deletePerformance() {
    setError(null);
    setEnabled(false);
    const answer = window.confirm("Are you sure you want to delete this performance?")
    if (!answer) {
      setEnabled(true);
      return;
    }

    delPerformance({id: performance.id})
      .then(responseHandler);
  }

  function savePerformance() {
    setError(null);
    setEnabled(false);

    if (performance.id) {
      putPerformance({id: performance.id, name, url})
        .then(responseHandler);
    } else {
      postPerformance({name, url})
        .then(responseHandler);
    }

  }

  function responseHandler(response: any) {
    setEnabled(true);
    if (response.ok) {
      onHide()
      loadData()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
  }

  return (
    <Modal show={show}
           className="member-edit"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <FormLabel className="mb-1 h-auto">Name</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={name}
              maxLength={40}
              onChange={(event: any) => setName(event.target.value)}
              isEditable={true}
              isEditing={true}
              setIsEditing={() => {
              }}
              placeholder="Name"
              ariaLabel="Name"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <FormLabel className="my-1 h-auto">Url</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={url}
              maxLength={256}
              onChange={(event: any) => setUrl(event.target.value)}
              isEditable={true}
              isEditing={true}
              setIsEditing={() => {
              }}
              placeholder="Url"
              ariaLabel="Url"
            />
          </div>
        </div>
        {error ?
          (
            <div className="row error">
              <div className="col-12">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            {performance.id ?
              <Button
                variant="secondary"
                className="mx-4"
                onClick={deletePerformance}
                disabled={!enabled}>Delete</Button>
              : null
            }
            <Button
              variant="secondary"
              className="ml-2"
              onClick={onHide}
              disabled={!enabled}
            >
              Cancel
            </Button>
            <Button
              onClick={savePerformance}
              style={{marginLeft: "10px"}}
              variant="primary"
              disabled={!enabled}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default PerformanceEdit;
